import { Link } from "react-router-dom";
import { clinic } from "@/data/clinic";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="absolute bottom-0 -left-32 w-96 h-96 rounded-full bg-accent-100/50 blur-3xl" />

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center py-14 md:py-24">
          <div>
            <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wide">
              <i className="ri-map-pin-line text-primary-600" />
              {clinic.cityLabel}
            </span>

            <h1 className="mt-6 font-heading text-3xl md:text-5xl font-extrabold leading-[1.1] text-foreground-950">
              Personalized Medical Care in Miami
            </h1>

            <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground-600 max-w-xl">
              Florida Family Clinic provides orthopedic care, pain treatment, diagnostic services,
              and medically supervised wellness support in a convenient outpatient setting.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-calendar-check-line" />
                Contact the Clinic
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
              >
                Learn About Our Services
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4">
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-stethoscope-line text-primary-700" />
                </span>
                <span className="text-sm font-medium text-foreground-800">Outpatient care</span>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-microscope-line text-accent-700" />
                </span>
                <span className="text-sm font-medium text-foreground-800">On-site diagnostics</span>
              </div>
              <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-secondary-700" />
                </span>
                <span className="text-sm font-medium text-foreground-800">Wellness support</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[300px] sm:h-[380px] lg:h-[520px] rounded-2xl overflow-hidden border border-background-200 bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20outpatient%20medical%20clinic%20interior%2C%20empty%20examination%20room%20with%20a%20simple%20treatment%20table%2C%20soft%20neutral%20walls%2C%20bright%20natural%20daylight%2C%20calm%20minimal%20healthcare%20environment%2C%20no%20people&width=900&height=1050&seq=ffc-hero-clinic-room&orientation=portrait"
                alt="Clean modern outpatient medical examination room at Florida Family Clinic in Miami"
                title="Florida Family Clinic outpatient examination room in Miami"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-5 right-5 sm:left-8 sm:right-auto sm:w-72 rounded-xl border border-background-200 bg-background-50 p-4">
              <div className="flex items-start gap-3">
                <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
                  <i className="ri-shield-check-line text-lg text-background-50" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">
                    A private medical practice
                  </p>
                  <p className="text-xs text-foreground-600 mt-1">
                    Serving patients in Miami, Florida.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}